import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Switch,
} from '@mui/material'
import { GreenChartTooltip } from '../../../../../common/components/GreenChartTooltip'
import React from 'react'
import { parseIntOr } from '../../../../../common/utils/parseNumericInput'

function MaxOpenPositionsField({ analyze, updateSetting }: { analyze: any; updateSetting: any }) {
  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel htmlFor="outlined-adornment-tradeLimit">Max Open Positions</InputLabel>
        <OutlinedInput
          id="outlined-adornment-tradeLimit"
          name="analyzeTrades.tradeLimit"
          type="number"
          // Display an empty string if tradeLimit is 0 (to represent infinity); otherwise, display the number.
          value={analyze.tradeLimit === 0 ? '' : analyze.tradeLimit}
          onChange={(e) => {
            // 0 is the "unlimited" sentinel, and what an empty box means.
            const limit = parseIntOr(e.target.value, 0)
            if (limit === 1) updateSetting('analyzeTrades.allowHedging', false)
            updateSetting('analyzeTrades.tradeLimit', limit)
          }}
          inputProps={{ min: 0 }}
          startAdornment={<InputAdornment position="start">#</InputAdornment>}
          label="Max Open Positions"
          placeholder="∞"
          endAdornment={
            <InputAdornment position="end">
              <GreenChartTooltip
                title={
                  <Box className="tooltip-text">
                    {analyze.tradeLimit === 1
                      ? 'Change max open positions to enable hedging'
                      : analyze.allowHedging
                        ? 'Disable hedging'
                        : 'Allow hedging'}
                  </Box>
                }
                arrow
              >
                <span>
                  <Switch
                    disabled={analyze.tradeLimit === 1}
                    checked={!!analyze.allowHedging}
                    onChange={(e) => updateSetting('analyzeTrades.allowHedging', e.target.checked)}
                    color="primary"
                  />
                </span>
              </GreenChartTooltip>
            </InputAdornment>
          }
        />
      </FormControl>
    </Grid>
  )
}

export default MaxOpenPositionsField
